<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 14:29:38
 * @FilePath: \jyrg-web\src\views\mobile\home\index.vue
 * @Description: 群侠传移动端 - 首页
-->
<template>
  <div class="main">
    <div class="advert-base-map">
      <!-- <div class="advert-home" @click="goHome()"></div> -->
    </div>
    
    <div class="advert-content" v-show="isShowAdvert" >
      <!-- el-form 标准写法 -->
      <el-form 
        :model="ruleForm" 
        :rules="rules" 
        ref="ruleForm" 
        label-width="110px" 
        class="demo-ruleForm form-box"
      >
        <!-- 所在大区 -->
        <el-form-item label="所在大区" prop="serverId" label-class-name="required-label">
          <el-select 
              v-model="ruleForm.serverId" 
              placeholder="请选择所在大区" 
              @change="handleServerChange"
            >
            <el-option
              style="font-size: 16px;"
              v-for="item in serverList"
              :key="item.serverId"
              :label="item.serverName"
              :value="item.serverId"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 安全手机 -->
        <el-form-item label="安全手机" prop="phone" label-class-name="required-label">
          <el-input 
            v-model="ruleForm.phone" 
            type="tel" 
            placeholder="请输入安全手机号码" 
            maxlength="11"
            style="width:100%;"
          ></el-input>
        </el-form-item>

        <!-- 角色名称 -->
        <el-form-item label="角色名称" prop="roleName" label-class-name="required-label">
          <el-select 
              v-model="ruleForm.roleName" 
              placeholder="请选择角色名称"  
              @click.native="getQueryRoles"
            >
            <el-option
              style="font-size: 16px;"
              v-for="item in rolesList"
              :key="item.roleName"
              :label="item.roleName"
              :value="item.roleName"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 充值金额 -->
        <el-form-item label="充值金额" prop="rechargeId" label-class-name="required-label">
          <el-select
              v-model="ruleForm.rechargeId"
              :popper-append-to-body="false"
              placeholder="请选择充值档位"    
              @focus="handleRechargeClick"
            >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.desc"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <button type="button" class="submit-btn" @click="topup()">立即充值</button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 支付选择弹框 -->
    <div class="voucher-pay-dialog-wrap">
      <el-dialog
        class="voucher-count"
        center
        width="500px"
        :visible.sync="voucherPayShow"
        append-to-body
      >
        <div class="voucherPay">
          <!-- 提示文字 -->
          <p class="self-qr-desc">请扫以下二维码进行支付</p>
          
          <!-- 二维码容器 -->
          <div class="qr-code-wrapper">
            <img :src="qrCodeImg" alt="支付二维码" />
          </div>

          <!-- 错误提示 -->
          <div class="error-tips" style="color: red;"></div>

          <!-- 底部微信扫码区域 -->
          <div class="self-qr-footer">
            <img src='../../../assets/image/pc/recharge/wxpay.jpg' alt="微信图标" />
            <span>微信扫码</span>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Notify } from "vant";
import webSite from "../../../api/webSite";
import QRCode from "qrcode";
import recharApi from '../../../api/rechargeApi'

export default {
  name: "Advert",
  metaInfo: {
    title: "《充值中心》",
  },
  data(){
    // 手机号校验
    let checkPhone = (rule, value, callback) => {
      var reg = /^1[3456789]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("安全手机号码格式不正确"));
      }
    }
    return {
      isSelected: false,
      voucherShow: false,
      productList: [],
      serverList: [],
      rolesList: [],
      voucherPayShow: false,
      buttonCheck: '',
      codeUrl: '',
      qrCodeImg: '',
      payAmount: '',
      selectedPayType: '',
      payErrorMsg: '',
        // 登录表单数据
        formData: {
        userName: '',
        password: ''
      },
      // 表单数据
      ruleForm: {
          appSource: "official",
          channelId: "official",
          deviceId: "4",
          payId: "302",
          playerId: "0",
          rechargeId:'',
          roleId: "0",
          serverId: '',
          p302:{phone:'', roleName:''},
          phone:'',
          roleName:''
      },
      // 表单校验规则
      rules: {
        serverId: [
          { required: true, message: '请选择所在大区', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入安全手机号码', trigger: 'blur' },
          { validator: this.noSpaces, trigger: 'blur' },
          { validator: checkPhone, trigger: "blur" },
        ],
        roleName: [
          { required: true, message: '请选择角色名称', trigger: 'change' }
        ],
        rechargeId: [
          { required: true, message: '请选择充值金额', trigger: 'change' }
        ],
      },
    };
  },
  computed: {
    // 判断是否显示内容
    isShowAdvert() {
      return sessionStorage.getItem('orderLogin') === '1';
    }
  },
  mounted() {
    this.getServerUrls(); // 获取所在大区
  },
  methods: {
    // 去除空格校验方法
    noSpaces(rule, value, callback) {
      if (value && value.indexOf(' ') !== -1) {
        callback(new Error('不能包含空格'));
      } else {
        callback();
      }
    },
    async handleServerChange(serverId) {
      if (serverId) {
        this.ruleForm.rechargeId = '';
        this.$refs.ruleForm.clearValidate('rechargeId'); 
        this.productList = [];
      } else {
        this.productList = [];
        this.ruleForm.rechargeId = '';
      }
    },
    async handleRechargeClick() { 
      if (this.ruleForm.serverId) {
        await this.getProductUrls(this.ruleForm.serverId);
        this.ruleForm.rechargeId = '';
      } else {
        this.productList = [];
      }
    },

    async getProductUrls(serverId) {
      let params = { serverId: serverId }
      let ulrs = await recharApi.getProductUrls(params);
      this.productList = ulrs.data;
    },

    async getServerUrls() {
      let ulrs = await recharApi.getServerUrls();
      this.serverList = ulrs.data;
    },

    async getQueryRoles() {
      let { phone } = this.ruleForm;
      let { serverId } = this.ruleForm;
      
      if (!serverId || serverId <= 0) {
        this.$message({
          type: 'error',
          message: "请选择服务器！"
        })
        return;
      }
      
      if (!phone) {
        this.$message({
          type: 'error',
          message: "请先输入安全手机号码！"
        })
        return;
      }
      
      let params = { 
        currentPhone: Number(phone), 
        serverId: Number(serverId)
      };
      
      try {
        let ulrs = await recharApi.getQueryRoles(params);
        this.rolesList = ulrs.data;
        
        // 如果没有角色信息，给出提示
        if (!this.rolesList || this.rolesList.length === 0) {
          this.$message({
            type: 'warning',
            message: "未查询到该手机号对应的角色信息！"
          })
        }
      } catch (error) {
        this.$message({
          type: 'error',
          message: "查询角色信息失败，请重试！"
        })
      }
    },
    // 生成二维码
    createQR(codeUrl) {  
      let opts = {
        errorCorrectionLevel:"H",
        type:"image/png",
        quality:0.3,
        margin:5,
        width:300,
        height:300,
        color: {
          dark:"#000",
          light:"#fff"
        }
      };

      QRCode.toDataURL(codeUrl, opts, (err, url) => {
        if (url === undefined) {
          this.$message({
            type: 'error',
            message:"支付调起失败"
          })
        }
        this.qrCodeImg = url
      })
    },

    // 充值
    async topup() {
      // 检查登录是否存在
      this.$set(this.formData, 'userName', sessionStorage.getItem('orderUserName'));
      this.$set(this.formData, 'password', sessionStorage.getItem('orderPwd'));
      const res = await webSite.orderLogin(this.formData);

      if (res?.code === 200) {
        if (res?.data?.userName) {
          sessionStorage.setItem('orderLogin', '1');
          this.$refs.ruleForm.validate(async (valid) => {
            if (valid) {
              const params = Object.assign({}, this.ruleForm)
              params.p302.roleName = params.roleName
              params.p302.phone = params.phone
              delete params.roleName
              delete params.phone

              let res = await recharApi.unifiedOrder(params);
              if (res.code == 200) {
                this.voucherPayShow = true;
                this.createQR(res.data.p302.codeUrl);
              } else {
                if (res.code == 40002) {
                  this.$message({
                    type: 'error',
                    message: "用户信息有误！"
                  })
                }
              }
            } else {
              return false;
            }
          });
        } else {
          this.errorMsg = '登录验证失败，用户名异常';
        }
      } else {
        this.$message({
                    type: 'error',
                    message: "账号密码错误！联系官网客服"
                  })
            sessionStorage.setItem('orderLogin', '');
            sessionStorage.setItem('orderUserName','');
            sessionStorage.setItem('orderPwd', '');
                  setTimeout(() => {
                  this.goPay();
                }, 1000);   
        }
    },
    goPay() {
      this.$router.push({ path: "/payhome" });
    },
}
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: auto;
  z-index: 1000;
  .advert-base-map {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height:150px;
    background: url("~@/assets/image/mb/payment/pay-home01.png");
    background-size: 100% 100%;
    
    .advert-home{
        width:65px;
        height:26px;
        margin-top: 5%;
        margin-left:1%;
        background: url("../../../assets/image/mb/payment/pay-button.png");
        background-size: 100% 100%;
    }
  }

  .advert-content{
    width: 90%;
    max-width: 600px;
    height: auto;
    margin: 30px auto 0;
    background-color: #fff;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 6px 30px rgba(230, 67, 67, 0.18);
    border: 1px solid #f0f0f0;

    ::v-deep .demo-ruleForm {
      width: 100%;
      
      .el-form-item {
        margin-bottom: 30px;
        display: flex;
        align-items: center;
      }
      
      .el-form-item__label.required-label:before {
        content: "◆";
        color: #d92121;
        margin-right: 6px;
        font-size: 22px;
      }

      .el-form-item__label {
        font-size: 20px;
        color: #5a2d0a !important;
        font-weight: bold;
        padding: 0;
      }

      .el-input__inner,
      .el-select__input {
        height: 56px !important;
        line-height: 56px !important;
        padding: 0 40px;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        font-size: 18px;
        color: #333;
        transition: border-color 0.2s;

        &:focus {
          outline: none;
          border-color: #d92121;
        }
        &::placeholder {
          color: #bbb;
        }
      }
    }

    .submit-btn {
      width: 292px;
      height: 64px;
      background: linear-gradient(90deg, #ff6b6b, #e64343);
      border: none;
      border-radius: 12px;
      color: #fff;
      font-size: 28px;
      font-weight: bold;
      margin-top: 20px;
      cursor: pointer;
      margin-left: 35px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0,0,0,0.2);
      }
    }
  }
}
</style>

<!-- 全局样式：支付弹框专用 -->
<style lang="scss">
.voucher-count {
  .el-dialog__body {
    padding: 30px 20px !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100% !important;
    box-sizing: border-box;
  }
  .el-dialog__headerbtn .el-dialog__close{
    font-size: 16px;
    color: #502d07;
  }
}

.voucherPay {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}
.self-qr-desc {
  font-size: 18px;
  text-align: center;
  margin: 0;
  width: 100%;
}
.qr-code-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    height: 250px;
    width: 250px;
    display: block;
    margin: 0 auto;
  }
}
.error-tips {
  font-size: 14px;
  text-align: center;
  width: 100%;
}
.self-qr-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  img {
    width: 30px;
    height: 25px;
  }
  span {
    font-size: 16px;
  }
}
</style>